import { render, staticRenderFns } from "./PainelComprasTic.vue?vue&type=template&id=2b465138"
import script from "./PainelComprasTic.vue?vue&type=script&lang=js"
export * from "./PainelComprasTic.vue?vue&type=script&lang=js"
import style0 from "./PainelComprasTic.vue?vue&type=style&index=0&id=2b465138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports